export const SCHEMAS = {
  departments: { label: "الأقسام", title: (i) => i.name, fields: [
    ["name", "الاسم"], ["tag", "الرمز (LSPD)"], ["slug", "المعرّف بالرابط (lspd)"], ["description", "الوصف", "area"], ["image", "رابط الصورة", "image"],
    ["duties", "المهام (كل سطر نقطة)", "lines"], ["requirements", "الشروط (كل سطر نقطة)", "lines"], ["rulesSlug", "معرّف القوانين"], ["voiceUrl", "رابط روم المقابلة"],
    ["open", "التقديم مفتوح", "bool"], ["soon", "قريباً", "bool"],
  ] },
  rules: { label: "القوانين", title: (i) => i.name, fields: [
    ["name", "اسم القسم"], ["tag", "الرمز"], ["slug", "المعرّف بالرابط"], ["summary", "ملخص", "area"], ["sections", "القوانين", "sections"],
  ] },
  news: { label: "الأخبار", title: (i) => i.title, fields: [["title", "العنوان"], ["tag", "التصنيف"], ["date", "التاريخ"], ["body", "النص", "area"]] },
  cars: { label: "السيارات", title: (i) => `${i.brand || ""} ${i.name || ""}`, fields: [
    ["brand", "الشركة"], ["name", "الموديل"], ["category", "الفئة"], ["price", "السعر"], ["topSpeed", "أقصى سرعة"], ["image", "رابط الصورة", "image"], ["description", "الوصف", "area"], ["specs", "المميزات (كل سطر نقطة)", "lines"],
  ] },
  businesses: { label: "البزنس", title: (i) => i.name, fields: [["name", "الاسم"], ["type", "النوع"], ["rentPrice", "سعر الاستئجار"], ["buyPrice", "سعر الشراء"], ["image", "رابط الصورة", "image"], ["features", "المميزات", "lines"]] },
  gangs: { label: "باكيجات العصابات", title: (i) => i.name, fields: [["name", "الاسم"], ["tag", "الرمز"], ["price", "السعر"], ["members", "عدد الأعضاء"], ["image", "رابط الصورة", "image"], ["description", "الوصف", "area"], ["features", "المميزات", "lines"]] },
  packages: { label: "الباكيجات", title: (i) => i.title, fields: [["title", "الاسم"], ["realPrice", "السعر الحقيقي"], ["ingameMoney", "المبلغ داخل اللعبة"], ["bonus", "المزايا", "lines"], ["popular", "الأكثر طلباً", "bool"]] },
  staff: { label: "الطاقم", title: (i) => i.name, fields: [["name", "الاسم"], ["role", "الرتبة"], ["username", "يوزر الديسكورد"], ["discord", "Discord ID"], ["avatar", "رابط الصورة", "image"]] },
};

export const sectionsToText = (secs = []) => secs.map((s) => [`## ${s.title}`, ...s.items.map((i) => `- ${i}`)].join("\n")).join("\n\n");

export const textToSections = (txt) => {
  const out = [];
  txt.split("\n").forEach((line) => {
    const l = line.trim();
    if (!l) return;
    if (l.startsWith("##")) out.push({ title: l.replace(/^#+\s*/, ""), items: [] });
    else {
      if (!out.length) out.push({ title: "عام", items: [] });
      out[out.length - 1].items.push(l.replace(/^[-•]\s*/, ""));
    }
  });
  return out;
};
